// extracted by mini-css-extract-plugin
module.exports = {"portal-page-courses":"styles__portal-page-courses___2v3B2","main-section":"styles__main-section___2IM4v","courses":"styles__courses___2PCCG","course":"styles__course___G3tD5"};